import { useEffect, useRef } from "react";

// Lazy, viewport-aware video. Plays when in view, pauses otherwise.
// Loads source only when near viewport (unless priority).
export default function Video({
  src,
  className = "",
  priority = false,
  cursor,
  ...rest
}) {
  const ref = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const play = () => {
      const p = el.play();
      if (p && p.catch) p.catch(() => {});
    };

    if (priority && !el.src) {
      el.src = src;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            if (!el.src) el.src = src;
            play();
          } else {
            el.pause();
          }
        });
      },
      { threshold: 0.15, rootMargin: "200px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [src, priority]);

  return (
    <div ref={wrapRef} className={`relative overflow-hidden ${className}`} data-cursor={cursor}>
      <video
        ref={ref}
        muted
        loop
        playsInline
        preload={priority ? "auto" : "none"}
        className="h-full w-full object-cover"
        {...rest}
      />
    </div>
  );
}
